import Enum from "../../../../../../enums/Enum";

const TimingSensitivityEnum = new Enum({
    MILD: {name: "Mild"},
    MODERATE: {name: "Moderate"},
    SEVERE: {name: "Severe"}
});

export default TimingSensitivityEnum;